import axios from "axios";

export const API_BASE = "/api";

export const api = axios.create({ baseURL: API_BASE, timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("camaroo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const here = window.location.pathname;
      if (here !== "/login") {
        localStorage.removeItem("camaroo_token");
        localStorage.removeItem("camaroo_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(err) {
  // Network / proxy failure (no response body or HTML error page from Cloudflare/ingress)
  if (!err?.response) {
    return err?.code === "ECONNABORTED"
      ? "The analytics server did not respond in time. Please retry."
      : (err?.message || "Network error");
  }
  const data = err.response.data;
  if (typeof data === "string" && (data.includes("Cloudflare") || data.includes("<!DOCTYPE") || data.includes("<html"))) {
    return "The analytics server returned an unexpected response. Your saved data has not been changed. Please retry.";
  }
  const d = data?.detail ?? data?.message;
  if (!d) return err.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  if (d?.msg) return d.msg;
  return JSON.stringify(d);
}
